import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routes = [
    {
        path:'/',
        name:'index',
		component: () => import('../views/IndexView.vue'),
		// meta: {hiddenHeader: true, hiddenFooter: true}  // 控制 Header、Footer 组件的显隐，默认显示
    },
    {
        path: '/index',
        name: 'indexAlias',
        redirect: '/',
    },
    {
        path: '/p',
        name: 'product',
        component: () => import('../views/ProductView.vue')
    },
    {
        // path: '/product/productId?productId=productId',
        path: '/p/pId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/e',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/n',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/n/nId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/a',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/c',
        name: 'call',
        component: () => import('../views/EmailView.vue')
    },
    {
        path: '/s',
        name: 'success',
        component: () => import('../views/EmailSuccessView.vue')
    },
    {
        path: '/d',
        name: 'download',
        component: () => import('../views/DownloadView.vue')
    }
];

const router = new VueRouter({
    routes
});

export default router
